import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { map, get, isEmpty } from 'lodash'

import { filters } from '../redux'

import DateRangeFilter from '../components/DateRangeFilter'

import './FiltersPanel.css'

const FILTERS = {
    [filters.TYPES.dateRange]: DateRangeFilter
}

const FiltersPanel = ({ items, isOpen }) => {
    if (isEmpty(items) || !isOpen) {
        return null
    }

    return (
        <div className="filters-panel">
            <div className="filters-body">
                { map(items, (type, name) => {
                    const Filter = get(FILTERS, type)
                    if (!Filter) {
                        return null
                    }

                    return <Filter key={ `filter-${name}` } name={ name } />
                }) }
            </div>
        </div>
    )
}

FiltersPanel.propTypes = {
    items  : PropTypes.object,
    isOpen : PropTypes.bool
}


function mapStateToProps(state) {
    return {
        isOpen: filters.isOpen(state)
    }
}

export default connect(mapStateToProps)(FiltersPanel)
